import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useRouterStore } from '../router-store';
const getWrappedComponentDisplayName = component => {
  let componentDisplayName = 'UNDEFINED';
  const {
    displayName,
    name
  } = component;
  if (displayName) {
    componentDisplayName = displayName;
  }
  if (name) {
    componentDisplayName = name;
  }
  return `withRouter(${componentDisplayName})`;
};
export const withRouter = WrappedComponent => {
  const displayName = getWrappedComponentDisplayName(WrappedComponent);
  const Component = WrappedComponent;
  const ComponentWithRouter = props => {
    const [{
      action,
      history,
      location,
      match,
      query,
      route
    }, {
      push,
      replace
    }] = useRouterStore();
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      action: action,
      history: history,
      location: location,
      match: match,
      push: push,
      query: query,
      replace: replace,
      route: route
    }));
  };
  ComponentWithRouter.displayName = displayName;
  return ComponentWithRouter;
};